export const TrafficFrom = {
  Autocomplete: "autocomplete",
  Checkout: "checkout",
  CommunicationTools: "communication-tools",
  External: "external",
  PopularChoices: "popular-choices",
  Recommended: "recommended",
  Search: "search",
  TopPicks: "top-picks", // rebranded to Foundational. However, will maintain as top-picks to prevent splitting of data
} as const;
